import { Checkbox } from '@flixbus/honeycomb-react';

import { VoucherFormBanner } from '../../components/VoucherForm/Banner';
import { VoucherFormBooking } from '../../components/VoucherForm/Booking';
import { VoucherFormProvider, useVoucherFormContext } from '../../components/VoucherForm/Context';
import { VoucherFormDiscount } from '../../components/VoucherForm/Discount';
import { VoucherFormInformation } from '../../components/VoucherForm/Information';
import {
  VoucherFormMaxUsageCount,
  VoucherFormQuantity,
} from '../../components/VoucherForm/Quantity';
import { VoucherFormRulesTitle } from '../../components/VoucherForm/Rules';
import { VoucherFormBlackoutPeriod } from '../../components/VoucherForm/Rules/BlackoutPeriod';
import { VoucherFormCountriesAndLines } from '../../components/VoucherForm/Rules/CountriesAndLines';
import { VoucherFormTravelPeriod } from '../../components/VoucherForm/Rules/TravelPeriod';
import { VoucherFormTrips } from '../../components/VoucherForm/Rules/Trips';
import { VoucherFormSection } from '../../components/VoucherForm/Section';
import {
  VoucherFormCampaignCode,
  VoucherFormStructure,
} from '../../components/VoucherForm/Structure';
import { VoucherFormSubmit } from '../../components/VoucherForm/Submit';
import { useRoles } from '../../context/RolesProvider';
import { ROLES } from '../../types/Roles';

import styles from './add-voucher.module.scss';

const template = {
  revenueType: 'Marketing',
  voucherType: 'Marketing',
  reasonField: false,
};

const DiscountTemplate = {
  disabled: false,
  discountType: 'percentage_marketing',
  excludeTypes: ['free_ride_hybrid', 'value_hybrid', 'credit_amount'],
  showFreeAncillaries: true,
};

const VoucherFormCountriesAndLinesTemplate = {
  allowedCountries: true,
  forbiddenCountries: true,
  relations: true,
  brandAllowlist: true,
  brandDisallowlist: true,
  transportType: true,
};

const MarketingForm = () => {
  const {
    formState: {
      payload: { prefixOnly },
    },
    handlePrefixOnlyChange,
  } = useVoucherFormContext();
  const { hasAnyRole } = useRoles();

  const canCreatePrefixOnly = hasAnyRole([
    ROLES.ROLE_VOUCHER_PORTAL_ADMIN,
    ROLES.ROLE_CREATE_MULTI_MARKETING_VOUCHER,
  ]);

  return (
    <form>
      <div className={styles.container}>
        <VoucherFormInformation template={template} />
        {canCreatePrefixOnly && (
          <VoucherFormSection
            title='Prefix-only campaign'
            subtitle='Create a single, multi-use campaign code (e.g. FLIX10) with no random characters appended.'
            inputs={
              <Checkbox
                id='prefix-only'
                name='prefix-only'
                value='prefix-only'
                label='Create a prefix-only campaign code'
                checked={prefixOnly}
                onChange={e => handlePrefixOnlyChange(e.target.checked)}
              />
            }
          />
        )}
        <VoucherFormQuantity template={{ disabled: prefixOnly }} />
        {prefixOnly ? <VoucherFormCampaignCode /> : <VoucherFormStructure />}
        {prefixOnly && <VoucherFormMaxUsageCount />}
        <VoucherFormDiscount template={DiscountTemplate} />
        <VoucherFormBooking />
      </div>
      <div className={styles.container}>
        <VoucherFormRulesTitle />
        <VoucherFormTrips />
        <VoucherFormCountriesAndLines template={VoucherFormCountriesAndLinesTemplate} />
        <VoucherFormTravelPeriod />
        <VoucherFormBlackoutPeriod />
      </div>
      <VoucherFormSubmit />
    </form>
  );
};

const AddMarketingPage = () => {
  return (
    <>
      <VoucherFormBanner title='Marketing Voucher' />
      <VoucherFormProvider>
        <MarketingForm />
      </VoucherFormProvider>
    </>
  );
};

export default AddMarketingPage;
